import { firestore, storage } from "../firebase/init";
import {
  serverTimestamp,
  Timestamp,
  collection,
  addDoc,
  deleteDoc,
  where,
  query,
  getDocs,
} from "firebase/firestore";
import {
  UploadTask,
  getDownloadURL,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import { getNumFilesAndTotalFileSize, getUID } from "./utils";

function bytestoMegabytes(bytes: number) {
  return bytes / (1024 * 1024);
}

const uploadFile = async (
  file: File | string,
  idx: number,
  uploadedSize: number,
  filename?: string,
  uid?: string | undefined
) => {
  if (!uid) {
    uid = await getUID();
  }

  let uploadTask: UploadTask;
  let fileSize: number;
  let fileName: string;

  if (typeof file === "string") {
    const response = await fetch(
      `https://us-central1-docuai-c7a15.cloudfunctions.net/cors-anywhere?u=${file}`
    );
    if (response.status !== 200) {
      throw new Error("Failed to fetch file");
    }
    const blob = await response.blob();
    const pdfBlob = new Blob([blob], { type: "application/pdf" });
    const fileRef = ref(storage, `${uid}/${filename?.replace("/", "-")}.pdf`);
    uploadTask = uploadBytesResumable(fileRef, pdfBlob);
    fileSize = pdfBlob.size;
    fileName = filename! + ".pdf";
  } else {
    fileName = file.name;
    fileSize = file.size;
    const fileRef = ref(storage, `${uid}/${fileName.replace("/", "-")}`);
    uploadTask = uploadBytesResumable(fileRef, file);
  }

  const { size, numFiles } = await getNumFilesAndTotalFileSize(uid!);

  if (numFiles + idx >= 10) {
    return Promise.reject("File limit exceeded");
  } else if (size + uploadedSize + bytestoMegabytes(fileSize) >= 50) {
    return Promise.reject("Storage limit exceeded");
  }

  return new Promise(async (resolve, reject) => {
    // Check if file already exists, if yes delete when new file is successfully uploaded
    const querySnapshot = await getDocs(
      query(
        collection(firestore, "files"),
        where("uid", "==", uid),
        where("fileName", "==", fileName),
        where("deleted", "==", false)
      )
    );

    uploadTask.on(
      "state_changed",
      (snapshot) => {},
      (error) => {},
      async () => {
        await getDownloadURL(uploadTask.snapshot.ref).then(
          async (downloadURL) => {
            await addDoc(collection(firestore, "files"), {
              uid,
              uploadedAt: serverTimestamp(),
              timestamp: Timestamp.fromDate(new Date()),
              fileName: fileName,
              fileSize: bytestoMegabytes(fileSize).toFixed(3) + " MB",
              url: downloadURL,
              deleted: false,
            });
          }
        );
        if (!querySnapshot.empty) {
          const doc = querySnapshot.docs[0];
          await deleteDoc(doc.ref);
        }
        resolve("");
      }
    );
  });
};

export default uploadFile;
